// Walmart analytics — dev-only: Walmart is deployed but hidden in prod. Like Shopify, no
// `feature` key (the Amazon marketplace capability gates do not apply to a Walmart seller
// account). The group and every child carry `envOnly`, and the route itself is hard-blocked
// outside development by devOnlyPaths in src/router/index.js.
const item = (title, to, icon) => ({
  title,
  action: 'read',
  subject: 'User',
  to,
  icon: { icon },
  envOnly: 'development',
});

export default [
  {
    title: 'Walmart',
    channel: 'walmart',
    icon: { icon: 'selfhst:walmart' },
    envOnly: 'development',
    children: [
      item('Item Performance', 'walmart-item-performance', 'ic:outline-insights'),
      item('Orders', { name: 'walmart-orders-tab', params: { tab: 'orders' } }, 'ic:outline-receipt-long'),
      item('Items', { name: 'walmart-items-tab', params: { tab: 'catalog' } }, 'ic:outline-inventory-2'),
      item('Inventory', { name: 'walmart-inventory-tab', params: { tab: 'current' } }, 'ic:outline-warehouse'),
      item('Finances', { name: 'walmart-finances-tab', params: { tab: 'settlement' } }, 'ic:outline-account-balance'),
      item('Account Health', { name: 'walmart-account-health-tab', params: { tab: 'performance' } }, 'ic:outline-verified-user'),
    ],
  },
];
